import { FC } from 'react';
import { Box, Button, Container, Grow, Stack, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../constants/paths.ts';

export const PermissionPage: FC = () => {
  const navigate = useNavigate();

  return (
    <Grow in>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          pt: 15,
          pb: 10
        }}
      >
        <Container
          sx={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography variant="h3" paragraph>
            Permission Required
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>
            You do not have permission to access this page. Please contact your administrator if you believe this is an error.
          </Typography>
          <Box sx={{ m: 10 }}>
            <FontAwesomeIcon icon={faShieldAlt} size="5x" />
          </Box>
          <Box display="flex" justifyContent="center">
            <Stack gap={3} width="100%" maxWidth="sm">
              <Button size="large" fullWidth variant="outlined" onClick={() => navigate(Paths.HOME)}>
                Go Home
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>
    </Grow>
  );
};
